import { getCall, putCall, postCall } from "../utils/calls";
import {
  dispatchErrorMessage,
  loadingToast,
  updateToast,
} from "../utils/toast";

export const getNews = async () => {
  const res = await getCall("/news/all");
  if (res[0]) {
    return res[0].news;
  } else return null;
};

export const getActiveNews = async () => {
  const res = await getCall("/news/active");
  if (res[0]) {
    return res[0].news;
  } else return null;
};

export const createNews = async (newSetting) => {
  const toastId = loadingToast();
  const data = {
    title: newSetting.title,
    description: newSetting.description,
    type: newSetting.type,
    published_at: newSetting.scheduleBool ? newSetting.schedule : null,
    duration_days: newSetting.durationDays,
  };
  const res = await postCall("/news/create", data);
  if (res[0]) {
    updateToast(toastId, "success", "Novedad creada correctamente.");
    return res[0].news;
  } else {
    dispatchErrorMessage(toastId, res, "Error al crear la novedad.");
    return null;
  }
};

export const updateNews = async (newsId, newSetting) => {
  const toastId = loadingToast();
  const data = {
    title: newSetting.title,
    description: newSetting.description,
    type: newSetting.type,
    published_at: newSetting.scheduleBool ? newSetting.schedule : null,
    duration_days: newSetting.durationDays,
  };
  const res = await putCall("/news/update/" + newsId, data);
  if (res[0]) {
    updateToast(toastId, "success", "Novedad actualizada correctamente.");
    return res[0].news;
  } else {
    dispatchErrorMessage(toastId, res, "Error al actualizar la novedad.");
    return null;
  }
};

export const deleteNews = async (newsId) => {
  const toastId = loadingToast();
  console.log("Deleting news with ID:", newsId);
  const res = await putCall("/news/delete/" + newsId);
  if (res[0]) {
    updateToast(toastId, "success", "Novedad eliminada correctamente.");
    return true;
  } else {
    dispatchErrorMessage(toastId, res, "Error al eliminar la novedad.");
    return false;
  }
};